import styled from '@emotion/styled'
import { Box } from 'stylewhere/components'

export const EmptyListMessage = styled(Box)`
  flex: 1;
  font-weight: 400;
  font-size: 26px;
  text-align: center;
  line-height: 1.4;
  white-space: pre-line;
`
